import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.scss']
})
export class LoginHeaderComponent implements OnInit {
  utilityLogo: string = '';

  constructor() { }

  ngOnInit(): void {
    this.utilityLogo = localStorage.getItem('kycUtilityLogo') || '';
  }

}
